import { ContentObserver } from '@angular/cdk/observers';
import { Component, NgZone, OnInit } from '@angular/core';
import { MatPseudoCheckbox } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CustomerAddress } from 'src/app/models/customer-address';
import { GooglePlace } from 'src/app/models/google-place';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CustomerAddressService } from 'src/app/services/customer-address.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ConfirmAddressComponent } from '../confirm-address/confirm-address.component';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { ConfirmAddressDialogComponent } from '../dialogs/confirm-address-dialog/confirm-address-dialog.component';
import { InputDialogComponent } from '../dialogs/input-dialog/input-dialog.component';

@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit 
{
  constructor(
    private currentinfoservice: CurrentInfoService,
    private navigationservice: NavigationService,
    public alertDialog: MatDialog,
    private localeservice:LocaleService,
    private deviceService: DeviceDetectorService,
    private ngzone: NgZone,
    private initializationservice:InitializationService,
    private route: ActivatedRoute,
    private router: Router,
    private customeraddressservice: CustomerAddressService
    ) {}

    directionsservice = new google.maps.DirectionsService();
    afterto='';

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

     return;
    }

    this.afterto = String(this.route.snapshot.queryParamMap.get('afterto'));

    var latlng = new google.maps.LatLng(this.currentinfoservice._currentInfo.PlaceLatitude, this.currentinfoservice._currentInfo.PlaceLongitude );

    let mapElement = document.getElementById('map');

    if(mapElement)
    {
      let map = new google.maps.Map(mapElement, 
      {
        center: latlng,
        zoom: 18,
        clickableIcons: false,
        disableDefaultUI: true 
      });

      let marker = new google.maps.Marker({map:map, position:latlng})

      if(this.currentinfoservice._currentInfo.ChargeByRegion === true)
      {
        var regions = this.currentinfoservice.getRegions();

        if(regions && regions.length > 0)
        {
          for (let index = 0; index < regions.length; index++) 
          {
            const element = regions[index];
            
            const circle = new google.maps.Circle({
              strokeColor: "#FF0000",
              strokeOpacity: 0.5,
              strokeWeight: 1,
              fillColor: "#000000",
              fillOpacity: 0.025,
              map,
              center: latlng,
              radius: element.EndDistance * 1000
            });
          }
        }
      }
      else
      {
        const circle = new google.maps.Circle
        (
          {
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: "#000000",
          fillOpacity: 0.05,
          map,
          center: latlng,
          radius: this.currentinfoservice.getMaxDistance() * 1000
        });
      }

      map.addListener("center_changed", () =>
      {
        let center = map.getCenter();

        marker.setPosition(center);
      });

      let confirmButton = document.getElementById('confirmButton');

      if(confirmButton)
      {
        let geocoder = new google.maps.Geocoder();

        confirmButton.addEventListener("click", () =>
        {
          var position = marker.getPosition();

          var storePlaceID = this.currentinfoservice._currentInfo.PlaceID;

          if(position && storePlaceID)
          {
            geocoder.geocode({ location:position.toJSON() },(results, status) =>
            {
              if(status === 'OK')
              {
                if(results.length > 0)
                {
                  var geocodeResult = results[0];

                  var request = 
                  { 
                    origin: new GooglePlace(storePlaceID), 
                    destination: new GooglePlace(geocodeResult.place_id), 
                    travelMode: google.maps.TravelMode.DRIVING 
                  };
      
                  this.directionsservice.route(request, (r,s) =>
                  {
                    if(s === 'OK')
                    {
                      var distance = r.routes[0].legs[0].distance.value / 1000;

                      var isWithinRange = this.currentinfoservice.isWithinOperationArea(distance)
                      
                      if(isWithinRange)
                        this.showAdressConfirmation(results[0], distance, storePlaceID, results[0].place_id);
                      else
                      {
                        this.ngzone.run(() =>
                        {
                          this.alertDialog.open(AlertDialogComponent, 
                            {
                              height: 'fit-content',
                              width: 'fit-content',
                              data: 
                              { 
                                title: this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Title"),
                                detail:this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Detail"), 
                                accept:this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Accept") 
                              }
                            });
                        });
                      }
                    }
                  });
                }
              }
            });
          }
        });
      }

      if (navigator.geolocation) 
      {
        navigator.geolocation.getCurrentPosition(
          (position) => 
          {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            map.setCenter(pos);

            this.showExplanation();
          }, (e) =>
          {
            this.showExplanation();
          });
      }
      else
        this.showExplanation();
    }
  }

  ngAfterViewInit()
  {
    let mapElement = document.getElementById('map');

    var topbar = document.getElementById("topbar");

    if(topbar && mapElement)
      mapElement.style.height = `${window.innerHeight - topbar.offsetHeight}px`;
  }

  showAdressConfirmation(address:google.maps.GeocoderResult, distance:number, originID:string, locationID:string)
  {
    this.ngzone.run(() =>
    {
      var inputDialog = this.alertDialog.open(ConfirmAddressDialogComponent, 
      {
        height: 'fit-content',
        width: '80vw',
        data: 
        { 
          address_components: address.address_components,
          geometry:address.geometry,
          formatted_address: address.formatted_address,
          locale: this.localeservice.getLocale(),
          distance: distance,
          originID: originID,
          locationID: locationID
        }
      });

      inputDialog.afterClosed().subscribe((customerAddress:CustomerAddress) =>
      {
        if(customerAddress)
        {
          this.customeraddressservice.setCustomerAddress(customerAddress);
                      
          this.ngzone.run(() =>
          {
            var appname = String(this.route.snapshot.paramMap.get('appname'));

            this.router.navigateByUrl('/' + appname + '/confirmaddress?afterto=' + this.afterto, { replaceUrl:true });
          });
        }
      })
    });
  }

  showExplanation()
  {
    if(this.deviceService.isMobile() || this.deviceService.isTablet())
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.MobileLocationPickerExplanation.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.MobileLocationPickerExplanation.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.MobileLocationPickerExplanation.Accept") 
        }
      });
    }
    else
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.PCLocationPickerExplanation.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.PCLocationPickerExplanation.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.PCLocationPickerExplanation.Accept") 
        }
      });
    }
  }

  showWarning()
  {

  }

  back()
  {
    this.navigationservice.back();
  }
}
